import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Navigation } from "lucide-react";
import ChapterHeader from "@/components/landing/ChapterHeader";
import { ADDRESS, PHONE_DISPLAY, PHONE_TEL, EMAIL, MAPS_LINK, MAPS_EMBED } from "@/lib/constants";
import { useLang } from "@/lib/i18n";

export default function Contatti() {
  const { t } = useLang();
  return (
    <section id="contatti" data-testid="contatti-section" className="grain relative overflow-hidden py-28 text-ivory sm:py-36">
      <div className="texture-tiles absolute inset-0" aria-hidden="true" />
      <div className="absolute inset-0 bg-night/90" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterHeader number="07" title={t.contatti.title} subtitle={t.contatti.subtitle} dark />
        <div className="grid gap-14 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8 }}
            className="space-y-8 lg:col-span-5"
          >
            <div className="flex items-start gap-4">
              <MapPin className="mt-1 h-5 w-5 shrink-0 text-gold" />
              <div>
                <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-ivory/50">{t.contatti.addressLabel}</p>
                <p data-testid="contatti-address" className="mt-1 font-display text-xl sm:text-2xl">{ADDRESS}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Phone className="mt-1 h-5 w-5 shrink-0 text-gold" />
              <div>
                <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-ivory/50">{t.contatti.phoneLabel}</p>
                <a
                  data-testid="contatti-phone"
                  href={PHONE_TEL}
                  className="mt-1 block font-display text-xl transition-colors hover:text-gold sm:text-2xl"
                >
                  {PHONE_DISPLAY}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Mail className="mt-1 h-5 w-5 shrink-0 text-gold" />
              <div>
                <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-ivory/50">{t.contatti.emailLabel}</p>
                <a
                  data-testid="contatti-email"
                  href={`mailto:${EMAIL}`}
                  className="mt-1 block font-display text-xl transition-colors hover:text-gold sm:text-2xl"
                >
                  {EMAIL}
                </a>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 pt-4">
              <a
                data-testid="contatti-call-button"
                href={PHONE_TEL}
                className="inline-flex items-center gap-2 rounded-full bg-bordeaux px-6 py-3.5 font-mono-alt text-[11px] uppercase tracking-[0.2em] text-ivory transition-transform duration-300 hover:scale-[1.04]"
              >
                <Phone className="h-4 w-4" /> {t.contatti.call}
              </a>
              <a
                data-testid="contatti-directions-button"
                href={MAPS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-ivory/30 px-6 py-3.5 font-mono-alt text-[11px] uppercase tracking-[0.2em] text-ivory transition-colors duration-300 hover:bg-ivory/10"
              >
                <Navigation className="h-4 w-4" /> {t.contatti.directions}
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <div
              data-testid="contatti-map"
              className="h-[420px] overflow-hidden rounded-[2rem] border border-ivory/20 shadow-[0_40px_100px_-40px_rgba(171,24,43,0.6)] lg:h-full"
            >
              <iframe
                title="Mappa Gelateria Imperiale"
                src={MAPS_EMBED}
                className="h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
